import React from "react";
import Header from "../component/Header/HeaderOfLogin";
import LoginForm from "../component/Login/LoginForm";
// import ChatWidget from '../component/ChatWidget/ChatWidget';

const LoginPage: React.FC = () => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-lightgreen">
      {/* Background Image Layer (Full Screen with Opacity) */}
      {/* <div
                className="absolute inset-0 w-full h-full bg-center bg-cover opacity-60 z-0"
                style={{ backgroundImage: "url('/assets/login-bg-picture.jpg')" }}
            ></div> */}

      {/* Header */}
      <div className="relative z-20">
        <Header />
      </div>

      {/* Main Content - Centered */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-[calc(9vh-150px)] px-4 sm:px-6 lg:px-8 mt-4 sm:mt-5 md:mt-5 lg:mt-5 xl:mt-5">
        {/* Centered Title */}
        <div className="text-center mb-12">
          <span className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-poppins font-semibold bg-[linear-gradient(to_right,_rgba(0,121,52,1),_rgba(38,36,111,1))] bg-clip-text text-transparent">
            Let’s Connect
          </span>
        </div>

        {/* Login Form - More Transparent */}
        <div className="w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl rounded-md overflow-hidden border border-white/30 shadow-lg bg-white/50">
          <div className="p-8 sm:p-10 md:p-12 flex justify-center items-center h-[70vh] xl:h-3/6 lg:h-3/5">
            <LoginForm />
          </div>
        </div>
      </div>

      {/* Chat Widget */}
      {/* <ChatWidget opacity="opacity-60" /> */}
    </div>
  );
};

export default LoginPage;
